<!--
CONSULTA FECHAMENTO/MOVIMENTO DE CAIXA POR PERIODO
-->

<template>
  <div class="container-full-width default-container p-3">
    <filtro :showfiltro="showfiltro" :params="paramsFiltro" @change="filtroChange" @cancel="showfiltro = false">
    </filtro>

    <div class="row">
      <div class="col-12 mb-2">
        <span class="lbl-deal-title mb-2 w-100">CONSULTA CONTROLE DO CAIXA</span>
      </div>
    </div>
    <hr />
    <div class="row mb-3 align-items-center">
      <div class="col-md-6 col-12">
        <v-button label="Filtro" :success="true" @click="handleShowFiltro"></v-button>
      </div>
    </div>

    <hr />

    <!-- ABERTURAS DE CAIXA -->

    <div class="row mb-2">
      <div class="col-12 lbl-title">
        ABERTURAS DE CAIXA DO PERÍODO
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-12" v-if="!caixasPeriodo || caixasPeriodo.lista.length == 0">
        Nenhum movimento encontrado
      </div>
      <div class="col-md-8" v-else>
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table class="table table-bordered table-sm responsive w-100">
              <thead>
                <tr>
                  <th colspan="1" class="text-center">
                    Data da Abertura
                  </th>
                  <th colspan="1" class="text-center">
                    Operador Abertura
                  </th>
                  <th colspan="1" class="numerico size100">
                    Valor na Abertura
                  </th>
                  <th colspan="1" class="text-center">
                    Status
                  </th>
                  <th colspan="1" class="text-center">
                    Operador Fechamento
                  </th>
                  <th colspan="1" class="text-center">
                    Data do Fechamento
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in caixasPeriodo.lista" :key="index">
                  <td class="textual">{{ row.dataabertura | formatDataHora }}</td>
                  <td class="textual">{{ row.operadorabertura }}</td>
                  <td class="numerico size100">{{ row.valorabertura | formatValue(2) }}</td>
                  <td class="textual">{{ row.status }}</td>
                  <td class="textual">{{ row.operadorfechamento }}</td>
                  <td class="textual">{{ row.datafechamento | formatDataHora }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- FORMAS DE PAGAMENTO -->

    <div class="row mb-2">
      <div class="col-12 lbl-title">
        Recebimentos por Forma de Pagamento
      </div>
      <div class="col-12">
        <!-- <v-button label="Excel" @click="loadData(true)"></v-button> -->
        <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-12" v-if="!formasPagamento || formasPagamento.lista.length == 0">
        Nenhum movimento encontrado
      </div>
      <div class="col-md-8" v-else>
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table class="table table-bordered table-sm responsive w-100">
              <thead>
                <tr>
                  <th colspan="1" class="text-center">
                    Descrição
                  </th>
                  <th colspan="1" class="numerico size100">
                    Valor
                  </th>
                  <th colspan="1" class="numerico size100">
                    Taxas (-)
                  </th>
                  <th colspan="1" class="numerico size100">
                    Valor Líquido
                  </th>
                  <th colspan="1" class="text-center">
                    %
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in formasPagamento.lista" :key="index">
                  <td class="textual">{{ row.descricao }}</td>
                  <td class="numerico size100">{{ row.valor | formatValue(2) }}</td>
                  <td class="numerico size100">{{ row.taxas | formatValue(2) }}</td>
                  <td class="numerico size100">{{ row.valorliquido | formatValue(2) }}</td>
                  <td class="numerico size100">{{ row.perc | formatValue(2) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="1" class="text-right total">Total</th>
                  <th class="numerico size100 total"> {{ formasPagamento.total | formatValue(2) }} </th>
                  <th class="numerico size100 total"> {{ formasPagamento.totaltaxas | formatValue(2) }} </th>
                  <th class="numerico size100 total"> {{ formasPagamento.totalliquido | formatValue(2) }} </th>
                  <th class="numerico size100 total"> {{ 100 | formatValue(2) }} </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div v-if="formasPagamento.lista.length > 0" class="col-md-4">
        <div class="border">
          <chart :params="paramsChartFormas"></chart>
        </div>
      </div>
    </div>


    <!-- MOVIMENTOS DE CAIXA -->

    <div class="row mb-2">
      <div class="col-12 lbl-title">
        MOVIMENTOS DO CAIXA
      </div>
      <div class="col-12">
        <!-- <v-button label="Excel" @click="loadData(true)"></v-button> -->
        <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-12" v-if="movimentosCaixa && movimentosCaixa.lista.length == 0">
        Nenhum movimento encontrado para o período
      </div>
      <div class="col-md-8" v-if="movimentosCaixa && movimentosCaixa.lista.length">
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table class="table table-bordered table-sm responsive w-100">
              <thead>
                <tr>
                  <th colspan="1" class="text-center">
                  </th>
                  <th colspan="1" class="text-center">
                    Data
                  </th>
                  <th colspan="1" class="textual">
                    Descrição
                  </th>
                  <th colspan="1" class="textual">
                    Observações
                  </th>
                  <th colspan="1" class="numerico size100">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in movimentosCaixa.lista" :key="index">
                  <td class="textual text-center">
                    <a class="text-center" @click="handleShowCaixa(row.codvabertura)">Detalhar caixa</a>
                  </td>
                  <td class="textual">{{ row.data | formatDataHora }}</td>
                  <td class="textual">{{ row.tipo }}</td>
                  <td class="textual">{{ row.obs }}</td>
                  <td class="numerico size100">{{ row.valor | formatValue(2) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="3" class="text-right total">Total</th>
                  <th class="numerico size100 total"> {{ movimentosCaixa.total | formatValue(2) }} </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>


    <!-- DEVOLUCOES -->

    <div class="row mb-2">
      <div class="col-12 lbl-title">
        Devoluções
      </div>
      <div class="col-12" v-if="devolucoes && devolucoes.lista.length">
        <!-- <v-button label="Excel" @click="loadData(true)"></v-button> -->
        <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-12" v-if="!devolucoes || devolucoes.lista.length == 0">
        Nenhum movimento encontrado
      </div>
      <div class="col-md-8" v-else>
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table class="table table-bordered table-sm responsive w-100">
              <thead>
                <tr>
                  <th colspan="1" class="text-center">
                    Data da Abertura
                  </th>
                  <th colspan="1" class="text-center">
                    Operador
                  </th>
                  <th colspan="1" class="numerico size100">
                    Valor
                  </th>
                  <th colspan="1" class="numerico size100">
                    CNPJ/CPF
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in devolucoes.lista" :key="index">
                  <td class="textual">{{ row.data | formatDataHora }}</td>
                  <td class="textual">{{ row.operador }}</td>
                  <td class="numerico size100">{{ row.valor | formatValue(2) }}</td>
                  <td class="textual">{{ row.cnpjcpf | formatCNPJCPF }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="3" class="text-right total">Total</th>
                  <th class="numerico size100 total"> {{ devolucoes.total | formatValue(2) }} </th>
                  <th class="text-right total"></th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- DESCONTOS CONCEDIDOS -->

    <div class="row mb-2">
      <div class="col-12 lbl-title">
        Descontos Concedidos
      </div>
      <div class="col-12" v-if="descontos && descontos.lista.length">
        <!-- <v-button label="Excel" @click="loadData(true)"></v-button> -->
        <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-12" v-if="!descontos || descontos.lista.length == 0">
        Nenhum movimento encontrado
      </div>
      <div class="col-md-8" v-else>
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table class="table table-bordered table-sm responsive w-100">
              <thead>
                <tr>
                  <th colspan="1" class="numerico">
                    Número do Pedido/Mesa
                  </th>
                  <th colspan="1" class="text-center">
                    Data da Abertura
                  </th>
                  <th colspan="1" class="text-center">
                    Operador
                  </th>
                  <th colspan="1" class="numerico size100">
                    Valor Desconto
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in descontos.lista" :key="index">
                  <td class="textual">{{ row.npedido }}</td>
                  <td class="textual">{{ row.data | formatDataHora }}</td>
                  <td class="textual">{{ row.operador }}</td>
                  <td class="numerico size100">{{ row.desconto | formatValue(2) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="3" class="text-right total">Total</th>
                  <th class="numerico size100 total"> {{ descontos.total | formatValue(2) }} </th>
                  <th class="text-right total"></th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- RESUMO DAS VENDAS POR GRUPO DE PRODUTOS -->
    <div class="row mb-2">
      <div class="col-12 lbl-title">
        Resumo das Vendas Por Grupo de PRODUTOS
      </div>
      <div class="col-12" v-if="resumoVendas && resumoVendas.lista.length > 0">
        <!-- <v-button label="Excel" @click="loadData(true)"></v-button> -->
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-12" v-if="!resumoVendas || resumoVendas.lista.length == 0">
        Nenhum produto encontrado
      </div>
      <div class="col-md-8" v-if="resumoVendas && resumoVendas.lista.length > 0">
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table class="table table-bordered table-sm responsive w-100">
              <thead>
                <tr>
                  <th colspan="1" class="textual">
                    Descrição
                  </th>
                  <th colspan="1" class="numerico size100">
                    Quantidade
                  </th>
                  <th colspan="1" class="numerico size100">
                    Valor
                  </th>
                  <th colspan="1" class="text-center">
                    %
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in resumoVendas.lista" :key="index">
                  <td class="textual">{{ row.descricao }}</td>
                  <td class="numerico size100">{{ row.qt | formatValue(2) }}</td>
                  <td class="numerico size100">{{ row.valor | formatValue(2) }}</td>
                  <td class="numerico size100">{{ row.perc | formatValue(2) }} %</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-if="resumoVendas.lista.length > 0" class="col-md-4">
        <div class="border">
          <chart :params="paramsChartResumo"></chart>
        </div>
      </div>
    </div>




  </div>
</template>

<script>
import DashCard from "../dashboards/dash-card";
import Chart from "./chart";
import Filtro from "./filtro";
import { apiORDSpost } from "../shared/api-functions";
import { apiDownload2 } from "../shared/api-functions";

export default {
  components: {
    DashCard,
    Filtro,
    Chart,
  },

  data() {
    return {
      showfiltro: false,

      dados: {},

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {
        periodo: {
          label: "Período",
          varios: false,
          data_inicio: null,
          data_termino: null,
        },
        filtros: [
          { nome: "filial", label: null, url: null, varios: false, values: [] },
          {
            nome: "segmento",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
        ],
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }],
      },


      colunas: [
      ],

      mounting: false,

    };
  },

  watch: {},

  methods: {
    handleShowCaixa(codvabertura) {
      this.$router.push('/varejo/controlecaixa/' + codvabertura)
    },
    clickRetornar() {
      this.$router.push('/painelvarejo')
    },

    varColor(val) {
      return { 'var-negative': val < 0, 'var-positive': val >= 0, '': val == 0 }
    },

    colSpan(index) {
      if (index > 0)
        return 6
      else
        return 4
    },

    handleShowFiltro() {
      this.showfiltro = true;
    },

    filtroChange(filtro) {
      this.showfiltro = false;
      this.filtro = filtro;
      this.paramsFiltro.filtros[0].values = this.filtro.filial

      this.loadData();
    },

    async loadData(excel) {

      let url = "consulta/vendas/varejomovimentocaixa";

      this.filtro.excel = excel;

      if (excel)
        apiDownload2(this, url, this.filtro, "post")
      else {
        this.mounting = true
        const data = await apiORDSpost(this.$store, url, this.filtro, "post")
        if (data) {
          this.dados = data
        }
      }
      this.mounting = false
    },

  },

  computed: {
    formasPagamento: function () {
      return this.dados.formasPagamento
    },

    descontos: function () {
      return this.dados.descontosConcedidos
    },

    devolucoes: function () {
      return this.dados.devolucoes
    },

    resumoVendas: function () {
      return this.dados.resumoVendas
    },

    movimentosCaixa: function () {
      return this.dados.movimentosCaixa
    },

    caixasPeriodo: function () {
      return this.dados.caixasPeriodo
    },

    dadosCaixa: function () {
      return this.dados.dadosCaixa
    },

    paramsChartFormas: function () {
      if (!this.formasPagamento)
        return null

      let grafico = [["Forma de Pagamento", "Valor"]]

      for (var x = 0; x < this.formasPagamento.lista.length; x++) {
        grafico.push([this.formasPagamento.lista[x].descricao, this.formasPagamento.lista[x].valor])
      }

      return {
        chart: { type: 'PieChart' },
        values: grafico
      }

    },

    paramsChartResumo: function () {
      if (!this.resumoVendas)
        return null

      let grafico = [["Grupo de Produto", "Valor"]]

      for (var x = 0; x < this.resumoVendas.lista.length; x++) {
        grafico.push([this.resumoVendas.lista[x].descricao, this.resumoVendas.lista[x].valor])
      }

      return {
        chart: { type: 'PieChart' },
        values: grafico
      }

    },

  },

  mounted() {

  },

  created() {
    this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate())
    this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate())
    this.loadData()
  },
}


</script>

<style>
table .numerico {
  min-width: 65px;
  text-align: right;
}

table .size130 {
  min-width: 130px;
}

table .size100 {
  width: 100px;
}

table .total {
  background: #c1c4c7;
  border: none;
}

table .var {
  min-width: 85px;
  text-align: center;
  background: #c1c4c7;
  display: inline-block;
}

table .var-negative {
  color: white;
  background: indianred;
}

table .var-positive {
  color: white;
  background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.consulta__total {
  display: flex;
  align-items: center;
  justify-content: center;
}

.consulta__total_valor {
  font-size: 40px;
  display: block;
  line-height: normal;
}

.consulta__cifrao {
  font-size: 16px;
  display: block;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/consultas/consulta-varejo-movimento-caixa.vue